// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// ShipmentDocumentParsePlanPath — source: shared/config/shipment_document_parse_plan_path.config.json
import type { ConfigStatusTone } from './config-status-tone';

export const SHIPMENT_DOCUMENT_PARSE_PLAN_PATH_VALUES = ["forced_type", "single_page", "email_envelope", "segmented", "single_span", "no_span_recognised", "segment_unavailable", "unreadable_pdf"] as const;
export type ShipmentDocumentParsePlanPath = (typeof SHIPMENT_DOCUMENT_PARSE_PLAN_PATH_VALUES)[number];

export const SHIPMENT_DOCUMENT_PARSE_PLAN_PATH_CHECK_MISSED_VALUES = ["segment_unavailable", "unreadable_pdf"] as const;

export const shipmentDocumentParsePlanPathBadgeClass: Record<ShipmentDocumentParsePlanPath, string> = {
  "forced_type": "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400",
  "single_page": "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400",
  "email_envelope": "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400",
  "segmented": "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
  "single_span": "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
  "no_span_recognised": "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400",
  "segment_unavailable": "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400",
  "unreadable_pdf": "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400",
};

export const shipmentDocumentParsePlanPathColor: Record<ShipmentDocumentParsePlanPath, string> = {
  "forced_type": "#6B7280",
  "single_page": "#6B7280",
  "email_envelope": "#6B7280",
  "segmented": "#10B981",
  "single_span": "#10B981",
  "no_span_recognised": "#F59E0B",
  "segment_unavailable": "#F59E0B",
  "unreadable_pdf": "#F59E0B",
};

export const shipmentDocumentParsePlanPathIcon: Record<ShipmentDocumentParsePlanPath, string> = {
  "forced_type": "Pin",
  "single_page": "File",
  "email_envelope": "Mail",
  "segmented": "Layers",
  "single_span": "FileCheck",
  "no_span_recognised": "FileQuestion",
  "segment_unavailable": "AlertTriangle",
  "unreadable_pdf": "FileWarning",
};

export const shipmentDocumentParsePlanPathTone: Record<ShipmentDocumentParsePlanPath, ConfigStatusTone> = {
  "forced_type": "neutral",
  "single_page": "neutral",
  "email_envelope": "neutral",
  "segmented": "success",
  "single_span": "success",
  "no_span_recognised": "warning",
  "segment_unavailable": "warning",
  "unreadable_pdf": "warning",
};

export const shipmentDocumentParsePlanPathI18nKey: Record<ShipmentDocumentParsePlanPath, "shipments:detail.documents.magicDrop.planPaths.forcedType" | "shipments:detail.documents.magicDrop.planPaths.singlePage" | "shipments:detail.documents.magicDrop.planPaths.emailEnvelope" | "shipments:detail.documents.magicDrop.planPaths.segmented" | "shipments:detail.documents.magicDrop.planPaths.singleSpan" | "shipments:detail.documents.magicDrop.planPaths.noSpanRecognised" | "shipments:detail.documents.magicDrop.planPaths.segmentUnavailable" | "shipments:detail.documents.magicDrop.planPaths.unreadablePdf"> = {
  "forced_type": "shipments:detail.documents.magicDrop.planPaths.forcedType",
  "single_page": "shipments:detail.documents.magicDrop.planPaths.singlePage",
  "email_envelope": "shipments:detail.documents.magicDrop.planPaths.emailEnvelope",
  "segmented": "shipments:detail.documents.magicDrop.planPaths.segmented",
  "single_span": "shipments:detail.documents.magicDrop.planPaths.singleSpan",
  "no_span_recognised": "shipments:detail.documents.magicDrop.planPaths.noSpanRecognised",
  "segment_unavailable": "shipments:detail.documents.magicDrop.planPaths.segmentUnavailable",
  "unreadable_pdf": "shipments:detail.documents.magicDrop.planPaths.unreadablePdf",
};

